import request from '../utils/request.util'

export default {
  getList (params) {
    return request.get('/customers', { params })
  },
  getTotal (params) {
    return request.get('/customers/total', { params })
  },
  chargeCurrentBalance (params) {
    return request.put('/customers/charge-current-balance', params)
  },
  getReport (params) {
    return request.get('/customers/reports', { params })
  },
  create (data) {
    return request.post('/customers', data)
  },
  update (data) {
    return request.put(`/customers/${data.id}`, data)
  },
  getOne (id) {
    return request.get(`/customers/${id}`)
  },
  getSimpleList (params) {
    return request.get('/customers/simple-list', { params })
  },
  remove (id) {
    return request.delete(`/customers/${id}`)
  }
}
